import { render, staticRenderFns } from "./statusi-vozila.editor.vue?vue&type=template&id=ab6b47ec&scoped=true&"
import script from "./statusi-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./statusi-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6b47ec",
  null
  
)

export default component.exports